import { render, staticRenderFns } from "./OpenBanking.vue?vue&type=template&id=0b9f8874&scoped=true"
import script from "./OpenBanking.vue?vue&type=script&lang=js"
export * from "./OpenBanking.vue?vue&type=script&lang=js"
import style0 from "./OpenBanking.vue?vue&type=style&index=0&id=0b9f8874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f8874",
  null
  
)

export default component.exports